import useActionTranslate from 'FlowBuilder/hooks/useActionTranslate'
import { useAct } from 'FlowBuilder/store'
import DraggableSelect from 'Shared/components/DraggableSelect'
import { channelConfig, ChannelConfigType } from '../ActionViews/Share/shareTypes'
import { ActionTranslatableKeysShare, actionTranslatablesShare } from 'FlowBuilder/lib/actionTranslatable'

export default function ShareActionForm({ actionId }) {
  const act = useAct()

  const action = useSel(s => s.actions.entities[s.local.selectedActionId])
  const config = action.config || { channels: [] }
  const value = config.channels || []
  const shareUrl = config.shareUrl ?? ''
  const shareUrlMode = config.shareUrl !== null && config.shareUrl !== undefined ? 'custom' : 'this_page'
  const { translated, fallback, flag, textContentUpdater } = useActionTranslate<ActionTranslatableKeysShare>({ actionId })

  const selectOptions = Object.entries(channelConfig).map(([key, config]) => ({ value: key, label: config.title }))

  const optionsMap = _.keyBy(selectOptions, 'value')
  const selectedOptions = value.map(channelValue => optionsMap[channelValue])

  function updateConfig(updates: Partial<typeof config>) {
    act.actions.upsert(actionId, { config: { ...config, ...updates } })
  }

  const additionalTranslateOptions: ActionTranslatableKeysShare[] = [
    'shareLinkText', 'copyLinkToShare', 'copied', 'skipButtonText', 'continueOnceShared',
  ]

  return <div className="box narrow">
    <h2 className='no-margin-top'>Share Page</h2>
    <div className='field margin-top'>
      <label className="bold">Share channels</label>
      <DraggableSelect
        options={selectOptions}
        value={selectedOptions}
        onChange={o => updateConfig({ channels: o ? o.map(x => x.value) : [] })}
        className="margin-top"
      />
    </div>
    <div className="flex gap-10 margin-top flex-wrap share-text-content">
      {selectedOptions.map(option => {
        const config: ChannelConfigType = channelConfig[option.value]
        return <div className='field'>
          <label className="bold dark-grey">{config.title} {flag}</label>
          <input
            className="margin-top half"
            type="text"
            value={translated[config.translateKey] ?? ''}
            placeholder={fallback[config.translateKey] ?? ''}
            onChange={e => textContentUpdater(config.translateKey, e.target.value)}
          />
        </div>
      })}
    </div>
    <div className="flex gap-10 margin-top flex-wrap share-text-content">
      {additionalTranslateOptions.map((key) => {
        const option = actionTranslatablesShare[key];
        return <div className='field' key={key}>
          <label className="bold dark-grey">{option.label} {flag}</label>
          <input
            className="margin-top half"
            type="text"
            value={translated[key] ?? ''}
            placeholder={fallback[key] ?? ''}
            onChange={e => textContentUpdater(key, e.target.value)}
          />
        </div>
      })}
    </div>
  </div>
}
